import { TFunction } from 'i18next';
import { GoogleMerchantSyncRunMode } from '@/models/googleMerchantSync.model';
import { TSelectOptions } from '@/ui';

export const getMerchantSyncModeOptions = (t: TFunction): TSelectOptions<GoogleMerchantSyncRunMode> => [
  { value: GoogleMerchantSyncRunMode.FULL, label: t('sync_full') },
  { value: GoogleMerchantSyncRunMode.DELTA, label: t('sync_delta') },
  { value: GoogleMerchantSyncRunMode.PRODUCT, label: t('sync_product') },
];
